import { connect } from 'react-redux'

import { RequestTypeOptions as BaseRequestTypeOptions } from './RequestTypeOptions'
import { setRequestType, setPoptartHistory } from 'store/MemberCommunication'

const mapDispatchToProps = {
  setRequestType,
  setPoptartHistory,
}

export const RequestTypeOptions = connect(
  null,
  mapDispatchToProps,
)(BaseRequestTypeOptions)
